module.exports = __webpack_public_path__ + "840a2a1b91828ed18e1243794583e9a8.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/orks-vignette-preview-460.webp
// module id = 496
// module chunks = 0